<div class="bank-statement-analysis-settings-page container-fluid">
    <mat-card appearance="outlined">
      <mat-card-content>
        <mat-tab-group [mat-stretch-tabs]="false" mat-align-tabs="start">
          <mat-tab label="LENDER LIST">
            <lender-table
             [type]="'lender'"
             [getBsaLenderListFn]="getBsaLenderListFn"
             [getBsaExcludedLenderListFn]="getBsaExcludedLenderListFn"
             [updateBsaLenderFn]="updateBsaLenderFn"
             [updateBsaExcludedLenderFn]="updateBsaExcludedLenderFn"
             [deleteBsaLenderFn]="deleteBsaLenderFn"
             [deleteBsaExcludedLenderFn]="deleteBsaExcludedLenderFn"
             [addBsaLenderFn]="addBsaLenderFn"
             [addBsaExcludedLenderFn]="addBsaExcludedLenderFn"
            ></lender-table>
          </mat-tab>

          <mat-tab label="EXCLUDED LENDER LIST">
            <lender-table
             [type]="'excluded-lender'"
             [getBsaLenderListFn]="getBsaLenderListFn"
             [getBsaExcludedLenderListFn]="getBsaExcludedLenderListFn"
             [updateBsaLenderFn]="updateBsaLenderFn"
             [updateBsaExcludedLenderFn]="updateBsaExcludedLenderFn"
             [deleteBsaLenderFn]="deleteBsaLenderFn"
             [deleteBsaExcludedLenderFn]="deleteBsaExcludedLenderFn"
             [addBsaLenderFn]="addBsaLenderFn"
             [addBsaExcludedLenderFn]="addBsaExcludedLenderFn"
            ></lender-table>
          </mat-tab>
          @if (isAdminUser) {
            <mat-tab label="OVERDRAFT QUARTERLY REVIEW">
              <overdraft-quarterly-review-list></overdraft-quarterly-review-list>
            </mat-tab>
          }
        </mat-tab-group>
      </mat-card-content>
    </mat-card>
</div>
